import {
  SectionElement,
  defineElement,
  onClick,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/new-faq/new-faq.ts
var NewFaq = class extends SectionElement {
  handleOpenButtonClick(elm) {
    const index = parseInt(elm.getAttribute("key"));
    if (this.accordions[index].isOpen) {
      this.accordions[index].close();
      this.plusIcons[index].classList.remove("rotate-180", "opacity-0");
      this.minusIcons[index].classList.add("opacity-0");
    } else {
      this.plusIcons.forEach((plusIcon) => {
        plusIcon.classList.remove("rotate-180", "opacity-0");
      });
      this.minusIcons.forEach((minusIcon) => {
        minusIcon.classList.add("opacity-0");
      });
      this.accordions.forEach((accordion) => __async(this, null, function* () {
        yield accordion.close();
      }));
      this.accordions[index].open();
      this.plusIcons[index].classList.add("rotate-180", "opacity-0");
      this.minusIcons[index].classList.remove("opacity-0");
    }
  }
  connectedCallback() {
    console.log("NewFaq connectedCallback", this.accordions.length);
    if (this.accordions.length > 0) {
      this.accordions[0].open();
      this.plusIcons[0].classList.add("rotate-180", "opacity-0");
      this.minusIcons[0].classList.remove("opacity-0");
    }
  }
};
__decorateClass([
  queryAll("[data-accordion]")
], NewFaq.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-plus]")
], NewFaq.prototype, "plusIcons", 2);
__decorateClass([
  queryAll("[data-minus]")
], NewFaq.prototype, "minusIcons", 2);
__decorateClass([
  onClick("[data-open-button]")
], NewFaq.prototype, "handleOpenButtonClick", 1);
NewFaq = __decorateClass([
  defineElement("new-faq")
], NewFaq);
export {
  NewFaq
};
